import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import { TYPOGRAPHY_PRIVATE_AREA_TITLE } from 'lib/typography';

const ReturnsSection = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  return (
    <Typography as="h2" className={TYPOGRAPHY_PRIVATE_AREA_TITLE}>
      {formatMessage({ id: 'privatearea.menu.returns', defaultMessage: 'Resi' })}
    </Typography>
  );
};

export default ReturnsSection;
